import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';
import PresetPreviewMedia from './PresetPreviewMedia';
import './PresetsCarousel.css';

function PresetsCarousel({ limit, showViewAll = false }) {
  const navigate = useNavigate();
  const [presets, setPresets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Загружаем пресеты из API
        const presetsResponse = await axios.get('/api/presets/', {
          params: { is_active: true }
        });
        
        // Преобразуем данные из БД в формат, ожидаемый компонентом
        // Теперь список содержит только: preset_id, title, preview_images, sort_order
        const loadedPresets = presetsResponse.data.map(preset => ({
          id: preset.preset_id,
          title: preset.title,
          previewImages: preset.preview_images || []
        }));
        
        setPresets(loadedPresets);
      } catch (error) {
        console.error('Error loading presets:', error);
        toast.error('Ошибка загрузки эффектов');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handlePresetClick = (preset) => {
    navigate(`/presets/${preset.id}`);
  };

  if (loading) {
    return (
      <div className="presets-grid-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  const displayedPresets = limit ? presets.slice(0, limit) : presets;

  return (
    <div className="presets-section">
      <div className="section-header">
        <h2>Эффекты</h2>
        {showViewAll && (
          <button 
            className="view-all-btn"
            onClick={() => navigate('/effects')}
          >
            Смотреть все
            <ArrowRight size={16} />
          </button>
        )}
      </div>

      <div className="presets-grid">
        {displayedPresets.map((preset) => (
          <div 
            key={preset.id} 
            className="preset-card"
            onClick={() => handlePresetClick(preset)}
          >
            <div className="preset-preview">
              <div className={`preset-images ${(preset.previewImages || []).length === 1 ? 'single-media' : ''}`}>
                {(preset.previewImages || []).slice(0, 2).map((mediaUrl, idx) => (
                  <PresetPreviewMedia
                    key={idx}
                    src={mediaUrl}
                    title={preset.title}
                    index={idx}
                  />
                ))}
              </div>
            </div>
            <div className="preset-info">
              <h3>{preset.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PresetsCarousel;
